/*
 * p-map の ラップ関数
 * https://github.com/sindresorhus/p-map
 */
import pMap from 'p-map';
/**
 * pMap のラップ関数
 * https://github.com/sindresorhus/p-map#pmapinput-mapper-options
 * @param items 対象配列
 * @param mapper map で回す処理
 * @param options
 * @param options.concurrency 同時処理件数
 * @returns
 */
export const promiseMap = pMap;
